import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header.jsx';
import Footer from '@/components/Footer.jsx';

function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Política de Privacidad | Faronexo</title>
        <meta name="description" content="Conoce cómo Faronexo protege y gestiona tus datos personales." />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-background">
        <section className="py-20 bg-muted/30 border-b border-border">
          <div className="max-w-4xl mx-auto container-padding text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Política de Privacidad
            </h1>
            <p className="text-lg text-muted-foreground">
              Cómo protegemos tus datos
            </p>
          </div>
        </section>

        <section className="py-16 md:py-24">
          <div className="max-w-3xl mx-auto container-padding prose prose-zinc dark:prose-invert prose-headings:font-bold prose-h2:text-2xl prose-h2:mt-12 prose-h2:mb-6 prose-p:text-muted-foreground prose-p:leading-relaxed prose-li:text-muted-foreground">
            
            <h2>1. Responsable del tratamiento de datos</h2>
            <p>
              El responsable del tratamiento de los datos personales recopilados a través de este sitio web es <strong>Faronexo</strong>. Nos comprometemos a proteger la privacidad de nuestros usuarios y clientes, garantizando que su información personal sea tratada con la máxima seguridad y en cumplimiento con las normativas de protección de datos aplicables.
            </p>

            <h2>2. Datos que recopilamos</h2>
            <p>
              A través de nuestros formularios de contacto y evaluación, podemos recopilar los siguientes datos personales y corporativos:
            </p>
            <ul>
              <li>Nombre y apellido</li>
              <li>Dirección de correo electrónico (email)</li>
              <li>Nombre de la empresa</li>
              <li>Cargo o puesto que ocupa</li>
              <li>Sitio web o dominio principal</li>
              <li>URL o API a revisar (opcional)</li>
              <li>Descripción del problema o necesidad</li>
              <li>Nivel de urgencia del requerimiento</li>
              <li>Cualquier otro dato proporcionado voluntariamente en los campos de texto libre</li>
            </ul>

            <h2>3. Finalidad del tratamiento</h2>
            <p>
              Los datos recopilados son utilizados exclusivamente para las siguientes finalidades:
            </p>
            <ul>
              <li>Responder a consultas, dudas o solicitudes de información.</li>
              <li>Evaluar solicitudes de servicio y realizar diagnósticos preliminares.</li>
              <li>Realizar seguimiento comercial y enviar propuestas de servicios.</li>
              <li>Brindar atención al cliente y soporte técnico.</li>
              <li>Mejorar la calidad de nuestros servicios y la experiencia del usuario en el sitio web.</li>
            </ul>

            <h2>4. Conservación de datos y seguridad</h2>
            <p>
              Los datos personales proporcionados se conservarán mientras se mantenga la relación comercial o durante los años necesarios para cumplir con las obligaciones legales. Faronexo implementa medidas de seguridad técnicas y organizativas adecuadas para salvaguardar su información contra el acceso no autorizado, la pérdida, alteración o destrucción.
            </p>

            <h2>5. Base legal</h2>
            <p>
              La base legal para el tratamiento de sus datos es el consentimiento explícito que usted otorga al completar y enviar nuestros formularios, así como la necesidad de dicho tratamiento para la ejecución de medidas precontractuales o contractuales en caso de contratar nuestros servicios.
            </p>

            <h2>6. Herramientas de analítica y cookies</h2>
            <p>
              Este sitio web puede utilizar cookies y herramientas de analítica web de terceros para comprender cómo los usuarios interactúan con el sitio y mejorar su funcionamiento. Estas herramientas recopilan información de forma anónima. Usted puede configurar su navegador para rechazar todas las cookies o para que le avise cuando se envíe una cookie.
            </p>

            <h2>7. Derechos del usuario</h2>
            <p>
              Como usuario, usted tiene derecho a:
            </p>
            <ul>
              <li><strong>Acceso:</strong> Conocer qué datos personales suyos estamos tratando.</li>
              <li><strong>Rectificación:</strong> Solicitar la corrección de datos inexactos o incompletos.</li>
              <li><strong>Actualización:</strong> Mantener su información al día.</li>
              <li><strong>Eliminación:</strong> Solicitar el borrado de sus datos cuando ya no sean necesarios para los fines para los que fueron recogidos.</li>
            </ul>
            <p>
              Para ejercer cualquiera de estos derechos, puede ponerse en contacto con nosotros a través de los medios indicados en la sección de contacto.
            </p>

            <h2>8. Contacto</h2>
            <p>
              Si tiene alguna pregunta sobre esta Política de Privacidad o sobre el tratamiento de sus datos, puede contactarnos enviando un correo electrónico a: <a href="mailto:contactos@faronexo.com" className="text-primary hover:underline">contactos@faronexo.com</a>.
            </p>

            <h2>9. Aceptación</h2>
            <p className="font-medium text-foreground p-4 bg-muted/50 rounded-lg border border-border mt-8">
              El uso de este sitio implica la aceptación de esta Política de Privacidad.
            </p>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default PrivacyPage;